"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paletteValueToCacheName = void 0;
/**
 * Takes a palette value and returns tuple with paletteValueTuple and cacheName
 * @param paletteValue - 'blue60'
 * @param spectrum - dark
 * @returns cacheName - 'blue60-1-dark'
 */
const paletteValueToCacheName = (paletteValue, spectrum) => {
  let cacheName;
  if (typeof paletteValue === 'string') {
    cacheName = `${paletteValue}-1`;
  } else {
    const alias = paletteValue[0],
      opacity = paletteValue[1];
    cacheName = `${alias}-${opacity}`;
  }
  return `${cacheName}-${spectrum}`;
};
exports.paletteValueToCacheName = paletteValueToCacheName;